export default __webpack_public_path__ + "static/media/icn-pdf.084a767a.svg";